export default __webpack_public_path__ + "static/media/4AF5C553-0D7A-430A-95A9-32FAC9F9308D_1_201_a.9a4c5464.jpeg";